<script lang="ts">
	import { handleStoreError } from '../../stores/GeneralStore';
	interface Props {
		id?: string | null;
		value?: string | null;
		placeholder?: string | null;
		propertyName: string;
		disabled?: boolean;
		maxLength?: number | null;
		callFunction?: ((object: any) => Promise<any>) | null;
		errors?: any;
		wrappInOptionalParameter?: boolean;
		positionDesign?: boolean;
		tabSwitcher?: boolean;
		rightAlign?: boolean;
		onBlur?: () => void;
		onKeyUp?: (e: KeyboardEvent) => void;
	}

	let {
		id = null,
		value = $bindable(),
		placeholder = null,
		propertyName,
		disabled = false,
		maxLength = 255,
		callFunction = null,
		errors = {},
		wrappInOptionalParameter = false,
		positionDesign = false,
		tabSwitcher = false,
		rightAlign = false,
		onBlur,
		onKeyUp
	}: Props = $props();

	let element: HTMLTextAreaElement | undefined = $state();

	let currentLength = $state(value ? value.length : 0);

	function handleBeforeInput(event: InputEvent) {
		if (event.target == null) return;

		const target = event.target as HTMLInputElement;

		if (positionDesign) {
			if (event.inputType == 'insertLineBreak') event.preventDefault();
			return;
		}

		//Build the next value
		const nextVal =
			target.value.substring(0, target.selectionStart || 0) +
			(event.data ?? '') +
			target.value.substring(target.selectionEnd || 0);

		if (maxLength && nextVal.length > maxLength) {
			event.preventDefault();
			currentLength = maxLength;
			return;
		}

		currentLength = nextVal.length;
	}

	function handleInput(event: Event) {
		if (callFunction) return;

		const target = event.target as HTMLInputElement;
		//Map it to a normal string
		value = target.value;
	}

	async function handleOnChange(event: Event) {
		//Get the target
		const target = event.target as HTMLInputElement;

		if (callFunction) {
			try {
				const dynamicObject: any = {};
				//Check if we should wrapp the property in an optional
				if (wrappInOptionalParameter) {
					dynamicObject[propertyName] = { value: target.value };
				} else {
					dynamicObject[propertyName] = target.value;
				}

				await callFunction(dynamicObject);

				//Map it to a normal string
				value = target.value;
			} catch (error) {
				//Check if we have an error type
				handleStoreError('general.patch_failed', error);

				// Revert to last known good value
				if (element) {
					element.value = value || '';
				}
			}
		} else {
			//Map it to a normal string
			value = target.value;
		}
	}

	function handleKeyDown(event: KeyboardEvent) {
		if (event.key === 'Enter') {
			event.stopPropagation();
		}
	}
</script>

<div class="h-full relative" class:positionDesign>
	<textarea
		{id}
		data-testid={propertyName}
		autocomplete="off"
		rows={positionDesign ? 1 : undefined}
		{disabled}
		bind:this={element}
		onfocus={() => element?.select()}
		class:text-right={rightAlign}
		class:switcher={tabSwitcher}
		oninput={handleInput}
		onchange={handleOnChange}
		onbeforeinput={handleBeforeInput}
		onblur={() => onBlur?.()}
		onkeyup={(e) => onKeyUp?.(e)}
		wrap="soft"
		{value}
		onkeydown={handleKeyDown}
		{placeholder}
	></textarea>

	{#if errors[propertyName]}
		<p class="text-red dark:text-orange text-sm">{errors[propertyName]}</p>
	{/if}
</div>
